import {Trans} from '@lingui/macro';
import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {IconButton} from '../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {SimpleDropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {UserThemeConsumer} from '../../../../../libs/shared/ui/src/theme/userThemeConsumer';

/*
 * Props.
 */

interface FormattingMoreDropdownButtonProps {
  children?: ReactNode;
}

/*
 * Style.
 */

const StyledMoreDiv = styled.div`
  transform: rotateZ(90deg);
`;

/*
 * Component.
 */

export const FormattingMoreDropdownButton: FC<FormattingMoreDropdownButtonProps> = (props) => (
  <PopoverCoordinator
    renderButton={(isOpen) => renderButton(isOpen)}
    renderModal={(modalProps) => renderModal(modalProps, props)}
  />
);

const renderButton = (isOpen: boolean): ReactNode => (
  <UserThemeConsumer>
    {(theme) => (
      <StyledMoreDiv>
        <IconButton
          iconName="more"
          label={<Trans id="formatting-more">More</Trans>}
          hasHover={isOpen}
          shouldPreventMouseDown
          isOpen={isOpen}
          color={theme.greys.shade80}
          hoverColor={theme.greys.shade80}
        />
      </StyledMoreDiv>
    )}
  </UserThemeConsumer>
);

const renderModal = (
  modalProps: PopoverTransferProps,
  {children}: FormattingMoreDropdownButtonProps,
): ReactNode => (
  <SimpleDropdown placement="top-end" {...modalProps}>
    {children}
  </SimpleDropdown>
);
